export const paths = {
   ROOT: '/',
   GET_STARTED: '/get-started',
   SELECT_FAVOURITES: '/select-favourites'
}